exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody.iphone-x .layout-dashboard.fix-top header {\n  padding-top: 30px;\n  height: 100px;\n}\n", ""]);

// exports
